import russianMainLang from './russian/mainLang'
import baseHeaderLang from './russian/baseHeaderLang'
import russianGoldkidFAQ from './russian/goldkidFAQ'
import russianGoldkidAdvantageLang from './russian/goldkidAdvantageLang'
import russianGoldkidOpenButton from './russian/goldkidOpenButton'
import russianGoldkidBlankLang from './russian/goldkidBlankLang'
import russianGoldkidOpenedLang from './russian/goldkidOpenedLang'
import russianPhotoVerification from './russian/photoVerification'

import russianGoldkidOpenFailedLang from './russian/goldkidOpenFailedLang'
import russianGoldkidAgreementLang from './russian/goldkidAgreementLang'
import russianOtpLang from './russian/otpLang'
import russianAlert from './russian/alertLang'
import russianToManager from './russian/toManagerLang'
import russianUnavailable from './russian/unavailable'
import russianError from './russian/errorLang'
import russianKidsList from './russian/kidsListLang'
import russianNoKidFound from './russian/noKidFound'
import russianAgreement from './russian/agreementLang'
import russianDebts from './russian/debts'
import russianNewYear from './russian/newYearUnavailable'

import kazakhDebts from './kazakh/debts'
import kazakhGoldkidBlankLang from './kazakh/goldkidBlankLang'
import kazakhAlert from './kazakh/alertLang'
import kazakhGoldkidAdvantageLang from './kazakh/goldkidAdvantageLang'
import kazakhGoldkidAgreementLang from './kazakh/goldkidAgreementLang'
import kazakhKidsList from './kazakh/kidsListLang'
import kazakhGoldkidFAQ from './kazakh/goldkidFAQ'
import kazakhGoldkidOpenButton from './kazakh/goldkidOpenButton'
import kazakhGoldkidOpenedLang from './kazakh/goldkidOpenedLang'
import kazakhGoldkidOpenFailedLang from './kazakh/goldkidOpenFailedLang'
import kazakhOtpLang from './kazakh/otpLang'
import kazakhToManager from './kazakh/toManagerLang'
import kazakhUnavailable from './kazakh/unavailable'
import kazakhError from './kazakh/errorLang'
import kazakhNoKidFound from './kazakh/noKidFound'
import kazakhBaseHeaderLang from './kazakh/baseHeaderLang'
import kazakhAgreement from './kazakh/agreementLang'
import kazakhNewYear from './kazakh/newYearUnavailable'
import kazakhPhotoVerification from './kazakh/photoVerification'

// AB test imports
import goldkidAdvantageAB from './russian/goldkidAdvantageAB' // 123
import goldkidStepperAB from './russian/goldkidStepperAB'
import goldkidMoreAB from './russian/goldkidMoreAB'
import goldkidConditionsAB from './russian/goldkidConditionsAB'
import rejectAB from './russian/rejectAB'

import kazakhGoldkidStepperAB from './kazakh/goldkidStepperAB'
import kazakhGoldkidMoreAB from './kazakh/goldkidMoreAB'
import kazakhsGoldkidConditionsAB from './kazakh/goldkidConditionsAB'
import kazakhGoldkidAdvantageAB from './kazakh/goldkidAdvantageAB' // 123
import kazakhRejectAB from './kazakh/rejectAB'

export default {
  'ru-RU': {
    ...russianGoldkidAdvantageLang,
    ...russianGoldkidOpenButton,
    ...russianGoldkidBlankLang,
    ...russianGoldkidOpenedLang,
    ...russianGoldkidOpenFailedLang,
    ...russianGoldkidAgreementLang,
    ...russianGoldkidFAQ,
    ...baseHeaderLang,
    ...russianMainLang,
    ...russianAlert,
    ...russianOtpLang,
    ...russianToManager,
    ...russianUnavailable,
    ...russianError,
    ...goldkidAdvantageAB,
    ...goldkidStepperAB,
    ...goldkidConditionsAB,
    ...goldkidMoreAB,
    ...rejectAB,
    ...russianKidsList,
    ...russianNoKidFound,
    ...russianAgreement,
    ...russianDebts,
    ...rejectAB,
    ...russianNewYear,
    ...russianPhotoVerification
  },
  'kk-KZ': {
    ...kazakhGoldkidAgreementLang,
    ...kazakhGoldkidAdvantageLang,
    ...kazakhGoldkidOpenButton,
    ...kazakhGoldkidBlankLang,
    ...kazakhGoldkidOpenedLang,
    ...kazakhGoldkidOpenFailedLang,
    ...kazakhBaseHeaderLang,
    ...kazakhGoldkidFAQ,
    ...russianMainLang,
    ...kazakhAlert,
    ...kazakhOtpLang,
    ...kazakhKidsList,
    ...kazakhToManager,
    ...kazakhUnavailable,
    ...kazakhNoKidFound,
    ...kazakhError,
    ...kazakhGoldkidAdvantageAB,
    ...kazakhGoldkidStepperAB,
    ...kazakhsGoldkidConditionsAB,
    ...kazakhGoldkidMoreAB,
    ...kazakhRejectAB,
    ...kazakhDebts,
    ...kazakhAgreement,
    ...kazakhRejectAB,
    ...kazakhNewYear,
    ...kazakhPhotoVerification
  }
}
